import { useTranslation } from "react-i18next";

interface SangatiQuadrantsProps {
  showCompatibility: boolean; // Indicates whether to show compatibility score or loading/ready text
  modeMatch: string; // For the background colors to display
  displayedScore: number; // The score to display if showCompatibility is true
  isLoading: boolean; // Indicates whether the compatibility score is being loaded
  handleCompatibility: () => void; // Function to trigger matching
}

const SangatiQuadrants = ({
  showCompatibility,
  modeMatch,
  displayedScore,
  isLoading,
  handleCompatibility,
}: SangatiQuadrantsProps) => {
  const { t } = useTranslation();

  // Shows either the score or the loading or ready text
  const sangatiQuadrantText = showCompatibility
    ? `${displayedScore}%`
    : isLoading
      ? t("loading")
      : t("ready");

  // Determines the background color of the Sangati Quadrants - Reversed per Palette.md
  const modeBackground = () => {
    switch (modeMatch) {
      case "dark_mode":
        return "light-bg";
      case "both_mode":
        return "mixed-bg"; // Using reverse gradient
      default:
        return "dark-bg";
    }
  };
  const sangatiBackground = showCompatibility
    ? modeBackground()
    : "bg-sangati-green border-sangati-orange";

  const handleClick = () => {
    if (!isLoading && !showCompatibility) {
      handleCompatibility();
    }
  };

  return (
    <div
      className={`absolute w-[100px] h-[100px] rounded-full flex justify-center items-center border-10 border-sangati-green
        ${sangatiBackground}
      `}
      onClick={handleClick}
    >
      {/* Text of Sangati Quadrants, shows compatibility score, loading or ready */}
      <span
        className={`text-white font-sharetech ${showCompatibility ? "green-stroke-text text-2xl" : "text-lg"}`}
      >
        {sangatiQuadrantText}
      </span>
    </div>
  );
};

export default SangatiQuadrants;
